module.exports = __webpack_public_path__ + "img/028-trash.34110a41.svg";